export const OfferStatus = {
    SELECTED: "SELECTED",
    REJECTED: "REJECTED",
    ANSWERED: "ANSWERED",
};

export const getStatusBadge = {
    SELECTED: "approve",
    REJECTED: "reject",
    ANSWERED: "",
    NO_ANSWER: "reject",
};

export const RejectCategory = {
    EXCLUSION: "EXCLUSION",
    CRITERIA_SELECTION: "CRITERIA_SELECTION",
    IRREGULARITY: "IRREGULARITY",
    ABNORMAL_PRICE: "ABNORMAL_PRICE",
    OTHER: "OTHER",
};
